/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input } from "reactstrap";
import { toast } from "react-toastify";
import api from "../../../../../services/axiosConfig";

function ModalNovoAlerta({ isOpen, onClose, alertaSelecionado }) {
    const [title, setTitle] = useState('');
    const [body, setBody] = useState('');
    const [required, setRequired] = useState(false);
    const [tipoConta, setTipoConta] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    

    useEffect(() => {
        if (alertaSelecionado) {
            setTitle(alertaSelecionado?.title);
            setBody(alertaSelecionado?.body);
            setRequired(alertaSelecionado?.required || false);
            setTipoConta(alertaSelecionado?.tipoConta || '');
        } else {
            setTitle('');
            setBody('');
            setRequired(false);
            setTipoConta('');
        }
    }, [alertaSelecionado, isOpen]);

    async function handleSubmit(e) {
        e.preventDefault();
        setIsLoading(true);

        const alertData = { 
            title, 
            body, 
            required, 
            tipoConta: tipoConta || null 
        };

        try {
            if (alertaSelecionado) {
                await api.put(`/alerta/${alertaSelecionado._id}/editar`, alertData);
                toast.success("Alerta atualizado com sucesso!");
            } else {
                await api.post("/alerta/criar-alerta", alertData);
                toast.success("Alerta criado com sucesso!");
            }
            onClose();
        } catch (error) {
            console.error("Erro ao salvar alerta:", error);
            toast.error("Ocorreu um erro ao salvar o alerta.");
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <Modal isOpen={isOpen} toggle={onClose} centered style={{ maxWidth: 600 }}>
            <Form onSubmit={handleSubmit}>
                <ModalHeader toggle={onClose}>
                    {alertaSelecionado ? "Editar Alerta" : "Criar Novo Alerta"}
                </ModalHeader>
                <ModalBody>
                    <FormGroup>
                        <Label for="title">Título</Label>
                        <Input
                            id="title"
                            name="title"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            required
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="body">Corpo do Alerta</Label>
                        <Input
                            id="body"
                            name="body"
                            type="textarea"
                            rows={5}
                            value={body}
                            onChange={(e) => setBody(e.target.value)}
                            required
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="tipoConta">Segmentar por Tipo de Conta (opcional)</Label>
                        <Input
                            id="tipoConta"
                            name="tipoConta"
                            type="select"
                            value={tipoConta}
                            onChange={(e) => setTipoConta(e.target.value)}
                        >
                            <option value="">Para Todos os Utilizadores</option>
                            <option value="usuario">Cortador</option>
                            <option value="influenciador">Influenciador</option>
                            <option value="afiliado">Afiliado</option>
                        </Input>
                    </FormGroup>
                    <FormGroup check style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <Input
                            id="required"
                            name="required"
                            type="checkbox"
                            checked={required}
                            onChange={(e) => setRequired(e.target.checked)}
                        />
                        <Label check for="required">
                            Este alerta é obrigatório?
                        </Label>
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={onClose} disabled={isLoading}>
                        Cancelar
                    </Button>
                    <Button color="primary" type="submit" disabled={isLoading}>
                        {isLoading ? "Salvando..." : "Salvar Alerta"}
                    </Button>
                </ModalFooter>
            </Form>
        </Modal>
    );
}

export default ModalNovoAlerta;